module.exports = __webpack_public_path__ + "static/media/girl-at-desk-confused.383c5335.svg";